// extracted by mini-css-extract-plugin
export default {"modal":"style_modal__59l-H","content":"style_content__8FEb7"};